module.exports = __webpack_public_path__ + "c5c695a6d799128402aef5c62af41678.ttf";